import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Col, Row } from 'antd';
import CardView from '../CardView';
import Spinner, { isSpinnerShowing } from '../Spinner';
import { paginate } from '../../utils/paginate';
import EmptyView from '../EmptyView';
import Pagination from '../Pagination';
import { defaultCardsData } from '../ProjectStatusMap';
import './projectGrid.css'
import { useWindowDimensions, getDimension, getIPSDimension } from './screenDetectorHook';
import IpsFMPDataCardView from 'components/CardView/IpsFMPDataCardView';
import Cookies from 'js-cookie';
import allfmp from '../../containers/Dashboard/allfmp.json'

export default withRouter(function IpsFMPProjectsGrid(props) {
  const { projects, onButtonClick, history, context, isLoading, status } = props;
  const {data} = allfmp;

  const fmpProjects = data;
  // const pageSize = 6;
  // const row = 3;

  const { height, width } = useWindowDimensions();

  const [pageSize, setPageSize] = useState(0);
  const [row, setRow] = useState(0);
  const [colSizeXl, setColSizeXl] = useState(0);
  const [pageNo, setPageNo] = useState(1)
  const existingFilters = useMemo(()=>JSON.parse(Cookies.get('filters')), [Cookies.get('filters')])

  // let pageSize = 12
  //     let row  =4
  //     let colSizeXl = 4

  useEffect(() => {
    const { pageSize, row, colSizeXl } = getIPSDimension(width);
    setColSizeXl(colSizeXl);
    setRow(row);
    setPageSize(pageSize);
  }, [width, height]);

  const [pageItems, setPageItems] = useState([]);

  // added when found searching and sorting issue for filter on top level empty use effect has been added


  useEffect(() => {
    handlePageChange(pageNo);
  }, [projects]);

  useEffect(() => {
    handlePageChange(1);

  }, [existingFilters]);


  useEffect(() => {
    handlePageChange(pageNo);
  }, [row]);


  function handlePageChange(page) {
    setPageNo(page)
    setPageItems(paginate(projects, page, pageSize));
  }
  return (
    <React.Fragment>
      <div className={'container-fluid'} style={{ paddingBottom: 16 }}>
        {!isLoading && projects && projects.length < 1 ? <EmptyView /> : ''}
        {(isLoading && projects && projects.length < 1) &&
          <Row gutter={16} equal-heights>
            {defaultCardsData.slice(0, row).map((item, index) =>

              <Col key={index} xs={24} md={12} xl={colSizeXl} >
                <IpsFMPDataCardView project={item} onButtonClick={onButtonClick} history={history} context={context} {...props} loading />
              </Col>)}
          </Row>
        }

        <Row gutter={16} equal-heights>
          {pageItems.slice(0, row).map((item, index) => (

            <Col key={item.bpid + item.stationName + item.workOrder + index} xs={24} md={12} lg={8} xl={colSizeXl}>
              <IpsFMPDataCardView
                project={item}
                onButtonClick={onButtonClick}
                history={history}
                context={context}
                {...props}

              />
            </Col>
          ))}
        </Row>
        {/* <Row gutter={16}>
                    {pageItems.slice(row, row + pageItems.length).map((item) =>
                        <Col key={item.id} xs={24} md={12} xl={6}>
                            <CardView project={item} onButtonClick={onButtonClick} history={history} context={context} {...props} />
                        </Col>)} 
                </Row> */}
        <Pagination
          total={projects.length}
          pageSize={pageSize}
          onChange={(page) => handlePageChange(page)}
          pageNo={pageNo}
          id='cardPagination'
        />
      </div>
    </React.Fragment>
  );
});